import { useTenantBranding } from 'providers/Tenant/TenantBrandingProvider';
import { deriveTenantColors, DEFAULT_TENANT_COLORS } from 'PDF/TemplateEngine/deriveTenantColors';

// Re-exportado para no romper a los consumidores existentes de este módulo
// (ver src/hooks/__tests__/useTenantColors.test.jsx). La fuente de verdad de
// los defaults vive en deriveTenantColors.js — la comparten esta hook (con
// branding público, dentro de React) y los flujos imperativos de envío de
// PDF (con la fila completa del tenant, fuera de React).
export { DEFAULT_TENANT_COLORS };

export const useTenantColors = () => {
  const { branding } = useTenantBranding() ?? {};
  return deriveTenantColors(branding);
};
